/** Colonnes obligatoires — alignées sur STANDARD_REQUIRED_COLUMNS (backend). */
export const STANDARD_IMPORT_COLUMNS = [
    'reservation_number',
    'activity_start_date',
    'activity_end_date',
    'uw_date',
    'activity_price',
    'first_name',
    'last_name',
    'email',
    'preferred_language',
    'phone_number',
    'activity_name',
    'company_name',
];

/** Colonnes optionnelles Excel — obligatoires si Reference.activity_type == "activity". */
export const STANDARD_IMPORT_OPTIONAL_TIME_COLUMNS = [
    'activity_start_time',
    'activity_end_time',
];
